// extracted by mini-css-extract-plugin
export default {"timeleft":"TimeleftCell-timeleft-eTmq3 TableRowCell-cell-giPrj"};